<script setup>
defineProps({
  // items: Array of [question:string, answerText:string]
  items: { type: Array, default: () => [] }
})
</script>

<template>
  <section class="block tight">
    <div class="wrap">
      <div class="sec-h"><h2>Frequently asked questions</h2></div>
      <div class="faq-list">
        <AccordionItem
          v-for="(item, i) in items"
          :key="i"
          :title="item[0]"
        >
          <p v-html="item[1]" />
        </AccordionItem>
      </div>
    </div>
  </section>
</template>
